const RegisterAdminStyles = {
  dialogBoxContainer: {
    width: "400px",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    padding: 2,
  },
};
export default RegisterAdminStyles;
